import { Typography } from '@mui/material';
import { compact } from 'lodash';
import React, { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  FormikTreeAdditionalItemSettingsComponentProps,
  FormikCheckbox,
  TradeMethodTreeSelect,
} from 'components';
import { TranslationNamespace } from 'i18n';

type Props = {
  fiatCurrencyId?: string;
  crossFiatCurrencyIds?: string[];
  hideTitle?: boolean;
};

export const ShopPayinTradeMethods: React.FC<Props> = ({
  crossFiatCurrencyIds = [],
  fiatCurrencyId,
  hideTitle,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.shops.manage',
  });
  const { t: tCommon } = useTranslation();

  const fiatCurrenciesIds = useMemo(
    () => compact([fiatCurrencyId, ...crossFiatCurrencyIds]),
    [crossFiatCurrencyIds, fiatCurrencyId],
  );

  const additionalItemSettings = useMemo(
    () => ({
      component: ({
        index,
        disabled,
      }: FormikTreeAdditionalItemSettingsComponentProps) => (
        <FormikCheckbox
          sx={{
            userSelect: 'none',
          }}
          name={`payinTradeMethodsConfigs[${index}].anyBank`}
          label={tCommon('features.shops.manage.fields.trade_method_any_bank')}
          indeterminate={false}
          disabled={disabled}
        />
      ),
      defaultValues: {
        anyBank: false,
      },
    }),
    [tCommon],
  );

  return (
    <Fragment>
      {!hideTitle && (
        <Typography variant="subtitle1">
          {`${t('sections.trade_methods.title')} (${tCommon('common.payin')})`}
        </Typography>
      )}

      <TradeMethodTreeSelect
        fieldName="payinTradeMethodsConfigs"
        fieldValueIdPropertyName="tradeMethodId"
        fiatCurrenciesIds={fiatCurrenciesIds}
        additionalItemSettings={additionalItemSettings}
      />
    </Fragment>
  );
};
